;(function () {
  class PropertyMapMarkerManager {
    constructor({ map, config, outletFn }) {
      this.map = map
      this.config = config
      this.outletFn = outletFn

      this.prev = { bounds: null, zoom: null }
      this.abortController = null
      this.activeInfoWindow = null // To keep track of the open info window
    }

    initializeMarkers() {
      this.#addInitialMarker()

      const dataToMarker = HB.mapHelpers.buildDataToMarker({
        gmap: this.map,
        kingpinId: this.config.kingpin_id,
        loadingHtml: this.config.marker_loading_html,
        markerAriaLabel: this.config.marker_aria_label,
        onClickMarker: (marker, event) => {
          this.handleMarkerClick(marker, event)
        },
      })

      this.fetchMarkers({
        incremental: false,
        dataToMarkerFn: dataToMarker,
        preloadOfferId: this.config.kingpin_id,
      })

      this.map.addListener("idle", () => {
        this.fetchMarkers({
          incremental: true,
          dataToMarkerFn: dataToMarker,
        })
      })
    }

    #addInitialMarker() {
      const initialMarker = new MapMarker({
        position: this.config.kingpin_position,
        ariaLabel: this.config.marker_aria_label,
        content: this.config.marker_loading_html,
        onClick: (marker, event) => {
          this.handleMarkerClick(marker, event)
        },
        containerClasses: ["google-maps-marker--container_kingpin"],
        map: this.map,
        id: this.config.kingpin_id,
      })
      window.HB.mapHelpers.resetMarkers([initialMarker])
    }

    handleMarkerClick(marker, event) {
      event.stopPropagation()
      event.preventDefault()
      if (!this.outletFn().hasOutlet) {
        console.warn("Property map card list not found.")
        return
      }

      const cardContent = `<div class='google-maps-offers-info-window'>${
        this.outletFn().outlet.findCardById(marker.id).cardTarget.outerHTML
      }</div>`

      const self = this // To ensure correct 'this' in callbacks if not using arrow functions

      const callbacks = {
        afterOpen: () => {
          this.map.panTo(marker.getPosition())
          this.map.panBy(0, -140)
          marker.select()
          $(document).trigger("info-window:open", marker.id)
        },
        afterClose: function () {
          marker.deselect()
          this.destroy() // 'this' here refers to SnazzyInfoWindow instance
          $(document).trigger("info-window:close", marker.id)
          self.activeInfoWindow = null
        },
      }

      this.closeAllInfoWindows()

      const infoWindow = new SnazzyInfoWindow({
        marker: marker,
        closeOnMapClick: true,
        content: cardContent,
        panOnOpen: false,
        shadow: false,
        pointer: false,
        callbacks: callbacks,
      })

      infoWindow.open()
      this.activeInfoWindow = infoWindow
    }

    closeAllInfoWindows() {
      if (this.activeInfoWindow) {
        this.activeInfoWindow.close()
        this.activeInfoWindow = null
      }
    }

    async fetchMarkers(options) {
      const { params, nextPrev } = HB.mapHelpers.buildFetchMarkersParams(
        this.map,
        this.prev,
        {
          clusteringThreshold: this.config.clusteringThreshold,
          kingpinId: this.config.kingpin_id,
          recommendedPositionStatus: this.config.recommended_position_status,
        },
      )
      this.prev = nextPrev
      if (!params) return // map not ready yet

      this.abortController?.abort()
      this.abortController = new AbortController()

      const qs = new URLSearchParams(params).toString()
      const url = `/map/markers?${qs}`

      try {
        const res = await fetch(url, { signal: this.abortController.signal })
        const markersData = await res.json()
        const processFn = window.HB.mapHelpers.processFetchedMarkers(options)
        processFn(markersData)
      } catch (e) {
        if (e.name !== "AbortError") console.error("fetchMarkers failed", e)
      }
    }

    destroy() {
      this.abortController?.abort()
      this.closeAllInfoWindows()
    }
  }

  window.HB = window.HB || {}
  window.HB.PropertyMapMarkerManager = PropertyMapMarkerManager
})()
